import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/observable';
import { Lead } from '../model/lead';
import { LeadserviceService } from '../service/leadservice.service';

@Component({
  selector: 'app-form-landing',
  templateUrl: './form-landing.component.html',
  styleUrls: ['./form-landing.component.scss']
})

export class FormLandingComponent implements OnInit {
  @Input() PointForm: string;

  endview = 0;
  lead: Lead;
  validatingFormContatto: FormGroup;
  constructor(private service: LeadserviceService, private fb: FormBuilder) { }




  ngOnInit() {
    console.log(this.PointForm);
    this.lead = new Lead();
    this.lead.cap="00000";
    this.lead.email="t@t.it";

    this.validatingFormContatto = this.fb.group({

      'nome': new FormControl(this.lead.nome, [Validators.required]),
      'cognome': new FormControl(this.lead.cognome, [Validators.required]),
      
     
      'telefono': new FormControl(this.lead.telefono, [Validators.required]),
      'privacy': new FormControl(this.lead.privacy1, [Validators.requiredTrue]),
      'termini': new FormControl(this.lead.privacy2, [Validators.requiredTrue]),
      'note': new FormControl(this.lead.Note, []),

    });
  

  }

  send() {
   
    if (this.validatingFormContatto.valid) {
      if (this.PointForm == null) { this.PointForm = ""; }
      console.log(this.diagnostic);
      this.endview = 1;
      this.service.setIddem(70);
        this.service.sendleads(this.lead, this.PointForm).subscribe(
          o => {

            this.endview = 2;
            console.log(this.endview);
            console.log(o);
            this.lead = new Lead();
          }, error => {this.endview = 2; console.log("errore api") }
        ) 
       
    }
    else {

      this.validatingFormContatto.controls['nome'].markAsTouched();
      this.validatingFormContatto.controls['cognome'].markAsTouched();
     
      
      this.validatingFormContatto.controls['telefono'].markAsTouched();
      this.validatingFormContatto.controls['termini'].markAsTouched();
      this.validatingFormContatto.controls['privacy'].markAsTouched();
    }


  }

  get diagnostic() { return JSON.stringify(this.lead); }

}



// WEBPACK FOOTER //
// ./src/app/form-landing/form-landing.component.ts